import { Autocomplete, Box, Button, TextField } from "@mui/material";
import React, { useContext } from "react";
import { useTextDomainContext, useUser } from "@/app/providers";
import { array, object, func } from "prop-types";

interface CustomerRoleTeam {
  Id?: string | number;
  name?: string;
  [key: string]: any;
}

interface CustomerRolesControlsProps {
  teams?: CustomerRoleTeam[];
  selectedCustomer?: CustomerRoleTeam | null;
  setSelectedCustomer: (value: CustomerRoleTeam | null) => void;
  setAddModalOpen: () => void;
}

/**
 *
 * @param root0
 * @param root0.teams
 * @param root0.selectedCustomer
 * @param root0.setSelectedCustomer
 * @param root0.setAddModalOpen
 */
export function CustomerRolesControls({
  teams,
  selectedCustomer,
  setSelectedCustomer,
  setAddModalOpen,
}: CustomerRolesControlsProps) {
  const { TextDomainContext } = useTextDomainContext();

  const { gettext } = useContext(TextDomainContext);
  const { user } = useUser();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "right",
        gap: 2,
      }}
    >
      <Autocomplete
        disableClearable
        disablePortal
        disabled={user?.demo}
        id="combo-box-demo"
        size="small"
        value={selectedCustomer}
        onChange={(_event, newValue) => setSelectedCustomer(newValue)}
        options={teams || []}
        getOptionLabel={(option: CustomerRoleTeam) => option.name || ""}
        sx={{
          flex: 1,
          maxWidth: 300,
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={gettext("Company")}
            placeholder={gettext("Select Company")}
          />
        )}
        renderOption={(props, option: CustomerRoleTeam) => (
          <li {...props} key={option.Id}>
            {option.name}
          </li>
        )}
      />

      <Button
        size="small"
        disabled={user?.demo}
        variant="contained"
        sx={{
          textDecoration: "none",
        }}
        onClick={() => setAddModalOpen()}
      >
        {gettext("Invite User")}
      </Button>
    </Box>
  );
}

CustomerRolesControls.propTypes = {
  teams: array,
  selectedCustomer: object,
  setSelectedCustomer: func,
  setAddModalOpen: func,
};
